module.exports = __webpack_public_path__ + "img/74.742cfa52.jpg";